import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import LogoutConfimation from "./LogoutConfimation";
import { logOut, useUser } from "../../redux/services/authSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import logo from "../../assests/BEFLogo.png";
import { FaBars } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";

const Navbar = ({ toggleSidebar }) => {
  const location = useLocation();
  const { pathname } = location;
  const { user } = useUser();
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const navigate = useNavigate();
  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const handleToggle = () => setConfirm((prevState) => !prevState);
  const menuRef = useRef();
  const handleLogout = () => {
    setTimeout(() => {
      navigate("/");
      setConfirm(!confirm);
      dispatch(logOut());
    }, 1000);
  };

  const confirmLogout = () => {
    handleLogout();
    toast.success("Logout successfully", {
      autoClose: 2000,
      pauseOnHover: false,
    });
  };
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        dropdownOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [dropdownOpen]);
  return (
    <>
      <header className="sticky top-0 z-50 h-16 md:h-20 flex items-center justify-between bg-card border-b border-border shadow-sm px-4 sm:px-5 md:px-8 font-sans">
        <div className="flex items-center gap-3">
          <button
            className="lg:hidden flex h-11 w-11 items-center justify-center rounded-xl bg-secondary text-xl text-primary transition-all duration-300 hover:text-accent"
            onClick={toggleSidebar}
            aria-label="Open menu"
          >
            <FaBars />
          </button>
          <div
            className="flex flex-col items-start justify-center cursor-pointer py-1 leading-none"
            onClick={() => navigate("/")}
          >
            <img src={logo} alt="Achiwon" className="h-6 sm:h-7 w-auto object-contain" />
            <span className="text-[10px] sm:text-xs text-[#204278] font-semibold tracking-wider leading-none mt-1">
              UPSC &amp; GPSC CSE
            </span>
          </div>
        </div>
        <div className="flex justify-end">
          <div className="items-center gap-x-3 flex sm:px-2">
            <div className="relative">
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  setDropdownOpen((prevState) => !prevState);
                }}
                className="flex items-center gap-2 cursor-pointer rounded-xl border border-transparent bg-secondary px-2 py-1.5 transition-all duration-300 hover:border-accent"
              >
                <span className="h-9 w-9 md:h-11 md:w-11 rounded-full ring-2 ring-secondary flex justify-center items-center overflow-hidden bg-card">
                  <img
                    src={logo}
                    alt={user.name}
                    className="w-full h-full rounded-full object-cover"
                  />
                </span>
                <div className="hidden sm:block text-left cursor-pointer pr-1">
                  <span className="block text-sm font-bold text-primary font-heading truncate max-w-[140px] md:max-w-[200px]">
                    {user?.firstName + " " + user?.lastName || "Welcome user"}
                  </span>
                  <span className="block text-[11px] font-semibold capitalize text-muted-foreground">{user.userType}</span>
                </div>
                <IoIosArrowDown className="text-primary" />
              </div>
              {dropdownOpen && (
                <div
                  ref={menuRef}
                  className="absolute right-0 top-14 w-56 rounded-xl border border-border bg-card p-2 shadow-theme z-50"
                >
                  <ul className="font-semibold space-y-1 mb-0">
                    <li onClick={toggleDropdown}>
                      <NavLink to="/change-password">
                        <button
                          type="button"
                          className={`${
                            pathname === "/change-password"
                              ? "text-white bg-primary"
                              : "text-foreground"
                          } py-2.5 px-4 w-full text-sm font-bold rounded-xl hover:text-accent hover:bg-secondary transition-all duration-300`}
                        >
                          Change Password
                        </button>
                      </NavLink>
                    </li>

                    <li onClick={handleToggle}>
                      <button
                        type="button"
                        className="py-2.5 px-4 w-full text-sm font-bold rounded-xl text-foreground hover:text-accent hover:bg-secondary transition-all duration-300"
                      >
                        Log Out
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {confirm && (
        <LogoutConfimation
          confirm={confirm}
          onLogout={confirmLogout}
          onCancel={() => setConfirm(!confirm)}
        />
      )}
    </>
  );
};

export default Navbar;
